/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react'
import { Button, Menu, Typography, Avatar } from 'antd';
import { Link } from "react-router-dom";
import { HomeOutline, MoneyCollectOutlined, BulbOutlined, FundOutlined, MenuOutlined, HomeOutlined } from "@ant-design/icons";
import icon from '../images/cryptocurrency.png';

export const Navbar = () => {
    const [activeMenu, setActiveMenu] = useState(true);
    const [screenSize, setScreenSize] = useState(null);

    useEffect(() => {
        const handleResize = () => setScreenSize(window.innerWidth);
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, [])

    useEffect(() => {
        if (screenSize <= 800) setActiveMenu(false);
        else setActiveMenu(true);
    }, [screenSize])


    return (
        <div className="nav-container">
            <div className="logo-container">
                <Avatar src={icon} size={'large'} />
                <Typography.Title level={2} className="logo">
                    <Link to="/">Crypto Verse</Link>
                </Typography.Title>
                <Button className="menu-control-container">
                    <MenuOutlined />
                </Button>
            </div>
            <Button className='menu-control-container' onClick={() => setActiveMenu(!activeMenu)}><MenuOutlined /></Button>
            {activeMenu && (
                <Menu theme="dark" mode="inline">
                    <Menu.Item icon={<HomeOutlined />}>
                        <Link to="/">Home</Link>
                    </Menu.Item>
                    <Menu.Item icon={<FundOutlined />}>
                        <Link to="/cryptocurrencies">Cryptocurrencies</Link>
                    </Menu.Item>
                    <Menu.Item icon={<MoneyCollectOutlined />}>
                        <Link to="/exchanges">Exchanges</Link>
                    </Menu.Item>
                    <Menu.Item icon={<BulbOutlined />}>
                        <Link to="/news">News</Link>
                    </Menu.Item>
                </Menu>
            )}
        </div>
    )
}
